"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.serialize = serialize;
exports.deserialize = deserialize;
exports.createMask = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _regexpSerializer = require("./regexp-serializer");

function buildUnmaskPattern(mask, placeholder) {
  var _context;

  var pat = '[';

  var _iterator = (0, _createForOfIteratorHelper2.default)(mask),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;

      if (!(item instanceof RegExp)) {
        pat += item === '-' ? "\\".concat(item) : item;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return new RegExp((0, _concat.default)(_context = "".concat(pat)).call(_context, placeholder, "]"), 'g');
}

var createMask = function createMask(_mask) {
  var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  var patters = buildUnmaskPattern(_mask, placeholder);
  return {
    unmask: function unmask(value) {
      if (_mask.length === 0) {
        return value;
      }

      return value.replace(patters, '');
    },
    mask: function mask(value) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var ret = '';

      if (_mask.length === 0 && !force) {
        return value;
      }

      if (value.length === 0 && !force) {
        return ret;
      }

      var _iterator2 = (0, _createForOfIteratorHelper2.default)(_mask),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;

          if (item instanceof RegExp) {
            while (value.length > 0 && !item.test(value.charAt(0)) && !(0, _startsWith.default)(value).call(value, ' ') && !(0, _startsWith.default)(value).call(value, placeholder)) {
              value = (0, _slice.default)(value).call(value, 1);
            }

            if (value.length > 0) {
              ret += value.charAt(0);
              value = (0, _slice.default)(value).call(value, 1);
            } else {
              ret += placeholder;
            }
          } else {
            ret += item;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return ret;
    }
  };
};

exports.createMask = createMask;

function serialize(mask) {
  return (0, _map.default)(mask).call(mask, function (m) {
    return m instanceof RegExp ? (0, _regexpSerializer.serialize)(m) : m;
  });
}

function deserialize(mask) {
  return (0, _map.default)(mask).call(mask, function (m) {
    return _regexpSerializer.regexMatcher.test(m) ? (0, _regexpSerializer.deserialize)(m) : m;
  });
}
